import * as globals from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 450px;
`;

export const ProjectSection = styled.div`
  margin: 16px 0;
  width: 215px;
`;

export const ListHeader = styled.div`
  align-self: flex-start;
  padding: 4px 24px;
  text-align: left;
  font-size: 13px;
  color: ${globals.textSecondary};
  white-space: nowrap;
  overflow: hidden;
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;
  white-space: nowrap;
  list-style-type: none;
  text-align: left;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 30px;
  color: @textColor;
`;

type ItemProps = {
  selected?: boolean;
};

export const ProjectItem = styled.div<ItemProps>`
  cursor: pointer;
  padding: 4px 24px;
  white-space: nowrap;
  overflow: hidden;
  &.disabled {
    color: ${globals.disabled};
    .icon {
      color: ${globals.disabled};
    }
  }
  &:hover {
    background: ${props => (props.selected ? globals.selected : globals.hover)};
  }
  background: ${props => (props.selected ? globals.selected : '')};
`;

export const HorizontalDivider = styled.div`
  border-left: 1px solid #e5e5e5;
  height: auto;
  margin-top: 20px;
`;

export const PanelSection = styled.div`
  margin: 16px 0;
  width: 320px;
`;

export const SearchWrapper = styled.div`
  padding: 4px 18px;
`;

type PanelItemProps = {
  selected?: boolean;
  hover?: boolean;
};

function getBackgroundColor(props: PanelItemProps): string {
  const {selected, hover} = props;
  if (selected && hover) {
    return globals.selectedHover;
  }
  if (selected) {
    return globals.lightSlateBlue;
  }
  if (hover) {
    return globals.hover;
  }
  return '';
}

export const PanelItem = styled.li<PanelItemProps>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 24px;

  &.disabled {
    color: ${globals.disabled};
    .icon {
      color: ${globals.disabled};
    }
  }
  &:hover {
    background: ${props =>
      props.selected ? globals.selectedHover : globals.hover};
  }
  ${props => css`
    ${
      (props.selected || props.hover) &&
      `background: ${getBackgroundColor(props)};`
    }
  `}
`;

export const TextWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
  &:hover {
    overflow: visible;
  }
  flex-grow: 0.6;
`;

export const CheckIconWrapper = styled.div`
  background: ${globals.blue};
  border-radius: 50%;
  width: 20px;
  height: 20px;
`;

export const CheckIcon = styled(Icon)`
  color: ${globals.white};
  display: flex;
  justify-content: center;
  align-: center;
  padding: 2px;
`;
